import React from 'react';
import css from './css.module.less';
import { Form } from 'src/components/RcForm';
import { EPreviewSize, EContentEnd } from 'src/types/common/SalesChannel';
import { get } from 'lodash';
const Visibility = (props) => {
  const {
    pcForm,
    mobileForm,
    tabletForm,
    selectedItem,
    moduleData,
    currentDraggableId,
  } = props;

  const pcData = Form.useWatch([], pcForm);
  const tabletData = Form.useWatch([], tabletForm);
  const mobileData = Form.useWatch([], mobileForm);

  const handleOnGetVis = (type) => {
    if (selectedItem === currentDraggableId) {
      if (type === EPreviewSize.WIDE) {
        const visible = get(pcData, 'visible');
        return visible;
      }
      if (type === EPreviewSize.TABLET) {
        const visible = get(tabletData, 'visible');
        return visible;
      }
      if (type === EPreviewSize.MOBILE) {
        const visible = get(mobileData, 'visible');
        return visible;
      }
    } else {
      const cData = get(moduleData, currentDraggableId);
      if (type === EPreviewSize.WIDE) {
        const pcData = get(cData, EContentEnd.pc);
        const visible = get(pcData, 'visible');
        return visible;
      }
      if (type === EPreviewSize.TABLET) {
        const tabletData = get(cData, EContentEnd.tablet);
        const visible = get(tabletData, 'visible');
        return visible;
      }
      if (type === EPreviewSize.MOBILE) {
        const mobileData = get(cData, EContentEnd.mobile);
        const visible = get(mobileData, 'visible');
        return visible;
      }
    }
    return false;
  };

  const pV = handleOnGetVis(EPreviewSize.WIDE);
  const tV = handleOnGetVis(EPreviewSize.TABLET);
  const mV = handleOnGetVis(EPreviewSize.MOBILE);

  return (
    <div className={css.container}>
      <div
        className={css.block}
        {...(pV ? { style: { backgroundColor: '#61d77c' } } : {})}></div>
      <div
        className={css.block}
        {...(tV ? { style: { backgroundColor: '#61d77c' } } : {})}></div>
      <div
        className={css.block}
        {...(mV ? { style: { backgroundColor: '#61d77c' } } : {})}></div>
    </div>
  );
};
export default Visibility;
